import { AxiosInstance } from 'axios';
import { BaseRequest } from '@trukt/types/BaseRequest';
import {
  IntegrationAppLiterals,
  Integration,
  IntegrationApp,
  IntegrationAppConfig,
} from '@trukt/types/Integration';
import { InvoiceBulkService } from './InvoiceBulkService';
import { SimplePaginatedResults } from '@trukt/types/PaginatedResults';

export type InvoiceIntegrationSearchRequest = BaseRequest<
  { app?: IntegrationAppLiterals },
  void,
  { invoiceGuid: string }
>;

export type InvoiceIntegrationSearchResponse = Integration[];

export type InvoiceIntegrationAppListSearchRequest = {
  domain: 'ACCOUNTING';
};
export type InvoiceIntegrationAppListSearchResponse = SimplePaginatedResults<IntegrationApp>;

export type InvoiceIntegrationAppConfigRequest = { appId: IntegrationApp['id'] };

export type InvoiceIntegrationAppConfigResponse = IntegrationAppConfig[];

export type InvoiceIntegrationUpdateRequest = BaseRequest<
  void,
  { externalId: string },
  { invoiceGuid: string; integrationId: string }
>;

export class InvoiceIntegrationService {
  instance: AxiosInstance;
  bulk: InvoiceBulkService;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.bulk = new InvoiceBulkService(instance);
  }

  search(request: InvoiceIntegrationSearchRequest) {
    return this.instance.get<InvoiceIntegrationSearchResponse>(
      `/invoices/${request.routeParams.invoiceGuid}/integrations`,
      {
        params: request.queryParams,
      },
    );
  }

  searchAppList(request: InvoiceIntegrationAppListSearchRequest) {
    return this.instance.get<InvoiceIntegrationAppListSearchResponse>(`/integrations/apps`, {
      params: request,
    });
  }

  getAppConfigs({ appId }: InvoiceIntegrationAppConfigRequest) {
    return this.instance.get<InvoiceIntegrationAppConfigResponse>(`/integrations/${appId}/configs`);
  }

  update({ routeParams, body }: InvoiceIntegrationUpdateRequest) {
    return this.instance.patch<void>(
      `/invoices/${routeParams.invoiceGuid}/integrations/${routeParams.integrationId}`,
      body,
    );
  }
}
